'use client'

import {
  IconCash,
  IconCircleCheck,
  IconCircleMinus,
  IconCircleX,
  IconCoins,
  IconPackage,
  IconRefresh,
  IconTruckDelivery
} from '@tabler/icons-react'
import clsx from 'clsx'

import { SaleOrder } from '../types'

import styles from './SaleOrderStatus.module.scss'

const ICON_SIZE = 16

const SaleOrderStatus = ({ status }: { status: SaleOrder['status'] }) => {
  switch (status) {
    case 'paid':
      return (
        <div className={clsx(styles.root, styles.neutral)}>
          <IconCoins size={ICON_SIZE} />
          Opłacone
        </div>
      )
    case 'new':
      return (
        <div className={clsx(styles.root, styles.neutral)}>
          <IconPackage size={ICON_SIZE} />
          Nowe
        </div>
      )
    case 'accepted':
      return (
        <div className={clsx(styles.root, styles.neutral)}>
          <IconPackage size={ICON_SIZE} />
          Przyjęte do realizacji
        </div>
      )
    case 'awaiting_payment':
      return (
        <div className={clsx(styles.root, styles.warning)}>
          <IconCash size={ICON_SIZE} />
          Oczekuje na płatność
        </div>
      )
    case 'in_delivery':
      return (
        <div className={clsx(styles.root, styles.neutral)}>
          <IconTruckDelivery size={ICON_SIZE} />W dostawie
        </div>
      )
    case 'delivered':
      return (
        <div className={clsx(styles.root, styles.success)}>
          <IconCircleCheck size={ICON_SIZE} />
          Dostarczone
        </div>
      )
    case 'cancelled':
      return (
        <div className={clsx(styles.root, styles.error)}>
          <IconCircleMinus size={ICON_SIZE} />
          Anulowane
        </div>
      )
    case 'not_delivered':
      return (
        <div className={clsx(styles.root, styles.error)}>
          <IconCircleX size={ICON_SIZE} />
          Niedostarczone
        </div>
      )
    case 'in_progress':
      return (
        <div className={clsx(styles.root, styles.info)}>
          <IconRefresh size={ICON_SIZE} />W trakcie przygotowania
        </div>
      )
    case 'partially_paid':
      return (
        <div className={clsx(styles.root, styles.warning)}>
          <IconCoins size={ICON_SIZE} />
          Częściowo opłacone
        </div>
      )
    default:
      return (
        <div className={clsx(styles.root, styles.neutral)}>
          <IconPackage size={ICON_SIZE} />
          Nowe
        </div>
      )
  }
}

export default SaleOrderStatus
